import { MapSidebar } from 'components/minute/sidebar/MapSidebar';
import { ScrollVertical } from 'elements/functional/ScrollVertical';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import styled from 'styled-components/macro';
interface Props {
    className?: string;
}

export const MapPanel = (props: Props) => {
    return (
        <S_MapPanel className={props.className}>
            <ScrollVertical light={true}>
                <motion.div {...ANIMATION_APPEAR}>
                    <MapSidebar />
                </motion.div>
            </ScrollVertical>
        </S_MapPanel>
    );
};

const S_MapPanel = styled.div`
    width: 100%;
    height: 100%;
`;
